import React from "react";
import { Plus, Eye, EyeOff, Palette, Pencil, Trash2 } from "lucide-react";
import { PALETTE, hexA, stopPointer } from "./treeConstants";

export function GroupsPanel({ groups, focusGroups, canEdit, onCreate, onToggleFocus, onApplyColor, onRename, onDelete, onRecolor }) {
  return (
    <div className="absolute left-4 top-16 z-30 w-60 rounded-xl border border-[#D8E0E8] bg-white/95 p-3 shadow-md backdrop-blur" data-testid="groups-panel" onPointerDown={stopPointer}>
      <div className="mb-2 flex items-center justify-between">
        <span className="font-serif text-sm font-semibold text-[#082D4A]">Groups</span>
        {canEdit && <button onClick={onCreate} data-testid="new-group-button" className="text-[#D4A017] hover:text-[#B0850F]"><Plus size={16} /></button>}
      </div>
      {groups.length === 0 && <p className="text-xs text-[#64748B]">No groups yet. Create one, then drag cards here or right-click a card → Groups.</p>}
      <div className="max-h-64 space-y-1.5 overflow-y-auto">
        {groups.map((g) => {
          const focused = focusGroups.has(g.id);
          return (
            <div key={g.id} data-group-drop={g.id} data-testid={`group-row-${g.id}`} className={`rounded-lg border-2 border-dashed p-2 ${focused ? "bg-[#E8EEF3]" : ""}`} style={{ borderColor: hexA(g.color, 0.5) }}>
              <div className="flex items-center gap-2">
                <span className="h-3 w-3 shrink-0 rounded-full" style={{ backgroundColor: g.color }} />
                <span className="flex-1 truncate text-sm font-medium">{g.name}</span>
                <span className="text-xs text-[#64748B]">{(g.member_ids || []).length}</span>
                <button onClick={() => onToggleFocus(g.id)} title="Show only this group" data-testid={`focus-group-${g.id}`} className={`${focused ? "text-[#082D4A]" : "text-[#94A3B8]"} hover:text-[#082D4A]`}>{focused ? <Eye size={14} /> : <EyeOff size={14} />}</button>
                {canEdit && (<>
                  <button onClick={() => onApplyColor(g)} title="Apply this group's colour to its members' cards" data-testid={`apply-group-color-${g.id}`} className="text-[#64748B] hover:text-[#082D4A]"><Palette size={13} /></button>
                  <button onClick={() => onRename(g)} title="Rename" data-testid={`rename-group-${g.id}`} className="text-[#64748B] hover:text-[#082D4A]"><Pencil size={13} /></button>
                  <button onClick={() => onDelete(g)} title="Delete" data-testid={`delete-group-${g.id}`} className="text-red-500 hover:text-red-700"><Trash2 size={13} /></button>
                </>)}
              </div>
              {canEdit && <div className="mt-1.5 flex gap-1">{PALETTE.slice(0, 8).map((c) => <button key={c} onClick={() => onRecolor(g, c)} className="h-4 w-4 rounded-full ring-1 ring-black/10" style={{ backgroundColor: c }} />)}</div>}
            </div>
          );
        })}
      </div>
      {canEdit && groups.length > 0 && <p className="mt-2 text-[10px] text-[#64748B]">Tip: drag a card onto a group to add them.</p>}
    </div>
  );
}
